// ** Initial State
// import {APPLYOO} from "../../../applyoo/applyoo";
import {cloneDeep} from "lodash";
import {sendApplyooComponentsResize} from "../../../applyoo/infrastructure/useApplyooComponent";


const initialState = {
    loginDetails: {},
    projectID : null ,
    jsGlobals: null,
    isProjectReady : false ,
    lstAllowedFileExtensions: ['.png','.jpg','.jpeg','.bmp','.gif','.js','.css','.dll','.aac','.abw','.arc','.avi','.azw','.bin','.bz','.bz2','.csh','.csv','.doc','.eot','.epub','.gz','.htm','.html','.ico','.ics','.jar','.json','.jsonld','.mid','.midi','.mjs','.mp3','.mpeg','.mpkg','.odp','.ods','.odt','.oga','.ogv','.ogx','.opus','.otf','.pdf','.php','.ppt','.rar','.rtf','.sh','.svg','.swf','.tar','.tif','.tiff','.ts','.ttf','.txt','.vsd','.wav','.weba','.webm','.webp','.woff','.woff2','.xhtml','.xls','.xml','.xul','.zip','.3gp','.3g2','.7z','.dot','.docm','.dotm','.xlt','.xla','.xlsm','.xltm','.xlam','.pot','.pps','.ppa','.mdb','.docx','.dotx','.xlsx','.xltx','.xlsb','.pptx','.potx','.ppsx','.ppam','.pptm','.potm','.ppsm'],
    maxAllowedFileSizeMB: 50,
    lstClientTags: [],
    themeConfig : {
        app: {
            appName: 'Taskeem',
            appLogoImage: require('@src/assets/images/logo/TaskeemLogo.svg').default,
            appLogoIconImage: require('@src/assets/images/logo/TaskeemIcon.svg').default,
        },
        layout: {
            isRTL: true,
            isHelpTopicsVisible: false,
            isHighContrast: true,
            skin: 'light', // light, dark, bordered, semi-dark
            routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
            type: 'vertical', // vertical, horizontal
            contentWidth: 'full', // full, boxed
            isHeaderPanelHidden: true,
            menu: {
                isHidden: false,
                isCollapsed: false
            },
            navbar: {
                // ? For horizontal menu, navbar type will work for navMenu type
                type: 'floating', // static , sticky , floating, hidden
                backgroundColor: 'white' // BS color options [primary, success, etc]
            },
            footer: {
                type: 'static' // static, sticky, hidden
            },
            customizer: false,
            scrollTop: true // Enable scroll to top button
        }
    },
    selectedProject: {},
    dicProjectParameters: {},
    menu: []
    //dicElementsFlatTree:{}
}

export const store_ProjectData = (state = initialState, action) => {
    switch (action.type) {
        case 'FREE_MEMORY':
            return {...state, initialState};

        case 'GetLoginDetails':
            const tempState = {...state}
            tempState.themeConfig.app.appName = action.loginD.ProjectName
            tempState.themeConfig.app.appLogoImage = action.loginD.ProjectLogoUrl
            return {...tempState}

        case 'changeProjectID':
            return { ...state, projectID: action.projectID}

        case 'setProjectReadyState':
            return { ...state, isProjectReady: true}

        case 'setHelpTopicsVisibility':
            return { ...state, isHelpTopicsVisible: action.isVisible}

        case 'changeJsGlobals':
            let lstClientTags = []
            let lstFileExtensions = []
            let maxAllowedFileSizeMB = 50

            if (!!action.JsGlobals?.MaxAllowedFileSizeMb){
                maxAllowedFileSizeMB = parseInt(action.JsGlobals.MaxAllowedFileSizeMb)
            }

            if (!!action.JsGlobals?.LstClientTags){
                lstClientTags = action.JsGlobals.LstClientTags
            }

            if (!!action.JsGlobals?.AllowedFileExtensions){
                lstFileExtensions = action.JsGlobals.AllowedFileExtensions.split(',')
            }

            return { ...state,
                jsGlobals: action.JsGlobals,
                lstAllowedFileExtensions: lstFileExtensions,
                lstClientTags: lstClientTags,
                maxAllowedFileSizeMB: maxAllowedFileSizeMB}

        case 'CHANGE_SELECTED_PROJECT':
            let newThemeConfig = {...state}.themeConfig
            newThemeConfig.app.appName = action.selectedProject.Project.ProjectName;

            return { ...state, selectedProject: action.selectedProject, themeConfig:newThemeConfig,projectID:action.projectID}

        case 'CHANGE_DEFAULT_PAGE':
            return { ...state, selectedProject: action.defaultPageCode}


        case 'HANDLE_RTL':
            let themeConfig = cloneDeep(state.themeConfig)
            themeConfig.layout.isRTL = action.value
            return { ...state, themeConfig: themeConfig }

        case 'CHANGE_MENU':
            return { ...state,  menu: action.menu }

        case 'HANDLE_MENU_COLLAPSED':
            sendApplyooComponentsResize()
            return state

        default:
            return state
    }
}

// export default store_ProjectData
